/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DeleteAction/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import No from './No/index'
import OtherActions from './OtherActions/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import Tysiav2DeleteFilled from 'DesignSystem/Svgs/Tysiav2DeleteFilled/index'
import Wait from './Wait/index'



/** @type {import('Simple/types.js').View} */
export default function DeleteAction({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/DeleteAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let automationIsIntegrationValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'is_integration',
})
let eventActionSingleGroupItemValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'singleGroupItem',
})
let eventActionTypeValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'type',
})
let constantData = 'wait'
let aggregateData = fromAggregate.equals(eventActionTypeValueData, constantData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 onClick={onClick}
 size="small"
 data="automation.is_integration"
 disabled={automationIsIntegrationValueData}
 data="event_action.singleGroupItem"
 disabled={eventActionSingleGroupItemValueData}
 data="event_action.type"
 data="'wait'"
 aggregate="/Data/aggregate.js equals"
 disabled={aggregateData}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2DeleteFilled
{...childProps}
  viewPath={`${viewPath}/Tysiav2DeleteFilled`}
 height={14}
 width={14}
 fill2={dtColorsNeutral400}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'OtherActions'}>
<OtherActions
  viewPath={`${viewPath}/OtherActions`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Wait'}>
<Wait
  viewPath={`${viewPath}/Wait`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}